import React, { useMemo } from 'react';
import missionService from '../../../services/missionsService';
import useServiceReducer from '../../../shared/hooks/useServiceReducer';
import { IdRoute } from '../../../types';
import Context from './MissionContext';
import missionReducer from './MissionReducer';

const MissionProvider: React.FC<IdRoute> = ({ id, children }) => {
  const [data, loading, , , , reload] = useServiceReducer(
    missionService.getMission,
    missionReducer,
    id
  );

  const value = useMemo(() => data && { data, reload, loading }, [data, reload, loading]);

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default MissionProvider;
